import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../../services';

@Component({
  selector: 'sn-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(
    private router: Router,
    public authService: AuthService
  ) { }

  /// NOTE: this component gets loaded which the route is set to '/' or root (ie. https://spa.salesnow.com)
  /// the sole responsibility of this component is to redirect to authenticated user's home page if able to retrieve the session user
  /// or redirect to the login component 
  ngOnInit() {
    //console.log('ngOnInit');
    this.processRouting('');
  }

  /// only trigger if we're not in an authentication process using auth token (see authService.ssoLogin)
  processRouting(source: string) {
    if (!this.authService.isLoginByAuthToken) {
      this.authService.populate().subscribe(
        (user) => {
          if (user && user.ID) {
            //console.log('processRouting:user home page');
            this.router.navigateByUrl(this.authService.getAuth().home_page);
          } else {
            this.authService.logoff();
          }
        }
      )
    }
  }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/home/home.component.ts